import { useTranslation } from 'react-i18next';
import { Button, Dropzone, Text } from '@/shared/ui';
import { FILE_UPLOAD_CONFIG } from '../constants';
import { validatePdfPageCount } from '../validatePdfPageCount';

type FileDropAreaProps = {
  selectedFile: File | null;
  onFileDrop: (files: File[]) => void;
  onFileRemove: () => void;
  onAnalyze: () => void;
  mode: 'create' | 'edit';
};

/**
 * ファイルドロップエリアのUI
 *
 * Dropzoneの`hideOnMaxFiles`を活用して、
 * 初期状態とファイル選択後の状態を1つのコンポーネントで管理する。
 */
export const FileDropArea = ({
  selectedFile,
  onFileDrop,
  onFileRemove,
  onAnalyze,
  mode,
}: FileDropAreaProps) => {
  const { t } = useTranslation();

  return (
    <div className="space-y-4">
      <Text variant="body">{t('ai.create-from-pdf.description')}</Text>

      <Dropzone
        accept={FILE_UPLOAD_CONFIG.accept}
        maxSize={FILE_UPLOAD_CONFIG.maxSize}
        hideOnMaxFiles
        title={t('ai.pdf-upload.dropzone.title')}
        subtitle={t('common.dropzone.subtitle')}
        description={t('ai.pdf-upload.dropzone.description')}
        validateFile={(file) => validatePdfPageCount(file, t)}
        onDrop={onFileDrop}
        onRemove={onFileRemove}
      />

      {/* ファイル選択後のみ表示 */}
      {selectedFile && (
        <>
          {mode === 'create' && (
            <Text variant="body" color="secondary">
              {t('ai.create-from-pdf.overwrite-warning')}
            </Text>
          )}
          <Button onClick={onAnalyze} className="w-full">
            {t('ai.pdf-upload.analyze-button')}
          </Button>
        </>
      )}
    </div>
  );
};
